// extracted by mini-css-extract-plugin
export default {"Label":"Label_Label__L8Mmq"};